import React, { useContext, useState } from "react";

const YearContext = React.createContext();
const YearUpdateContext = React.createContext();

export function useYear() {
  return useContext(YearContext);
}

export function useYearUpdate() {
  return useContext(YearUpdateContext);
}

export function YearProvider({ children }) {
  const [year, setYear] = useState(2022);

  function updateYear(y) {
    setYear(y);
  }

  return (
    <YearContext.Provider value={year}>
      <YearUpdateContext.Provider value={updateYear}>
        {children}
      </YearUpdateContext.Provider>
    </YearContext.Provider>
  );
}
